export const stateSelector = (state) => {
    return state;
};